import { callFunction } from "./functions-client";

// Placement fees & Connect payouts (Phase 2 slice C, ADR-0020). Dark build —
// nothing charges until the server's PLACEMENTS_ENABLED flag is on.

export type PlacementState =
  | "pending" | "charged" | "held" | "settled" | "refunded" | "clawed_back" | "canceled";

export interface Placement {
  id: string;
  job_application_id: string | null;
  company_account_id: string;
  driver_account_id: string;
  recruiter_account_id: string | null;
  fee_cents: number;
  take_cents: number;
  recruiter_net_cents: number;
  state: PlacementState;
  company_confirmed: boolean;
  driver_confirmed: boolean;
  guarantee_ends_at: string | null;
  created_at: string;
}

/** Recruiter: start/continue Stripe Connect Express onboarding → hosted URL. */
export const connectOnboard = () =>
  callFunction<{ url: string }>("payments/connect/onboard", { body: {} });

export const connectStatus = () =>
  callFunction<{ onboarded: boolean; configured: boolean }>("payments/connect/status", { method: "GET" });

/** Confirm a hire (company or driver side). Creates the placement on first call. */
export const confirmPlacement = (job_application_id: string, recruiter_account_id?: string) =>
  callFunction<{ placement: Placement; enabled: boolean; client_secret?: string; note?: string }>(
    "payments/placements/confirm",
    { body: { job_application_id, ...(recruiter_account_id ? { recruiter_account_id } : {}) } },
  );

export const placementStatus = () =>
  callFunction<{ placements: Placement[]; enabled: boolean }>("payments/placements/status", { method: "GET" });

/** Admin (finance): release after the 90-day window; clawback a failed placement. */
export const settlePlacement = (placement_id: string) =>
  callFunction<{ placement: Placement }>("payments/placements/settle", { body: { placement_id } });

export const clawbackPlacement = (placement_id: string, reason?: string) =>
  callFunction<{ placement: Placement }>("payments/placements/clawback", { body: { placement_id, reason } });

export const feeUsd = (cents: number) => `$${(cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2 })}`;
